module.exports = require("./mg.js");